import { TextField, MenuItem, Checkbox, ListItemText } from "@mui/material";

const OPTIONS = [
  "First Growths",
  "Second Growths",
  "Third Growths",
  "Fourth Growths",
  "Fifth Growths",
  "Grand Cru",
  "Premier Cru",
];

const PrimaryClassificationSelector = ({ value, onChange }) => {
  const selected = Array.isArray(value) ? value : [];

  return (
    <TextField
      select
      size="small"
      label="Primary Classification"
      fullWidth
      value={selected}
      onChange={(e) => onChange(e.target.value)}
      SelectProps={{
        multiple: true,
        renderValue: (sel) => sel.join(", "),
      }}
    >
      {OPTIONS.map((opt) => (
        <MenuItem key={opt} value={opt}>
          <Checkbox checked={selected.includes(opt)} size="small" />
          <ListItemText primary={opt} />
        </MenuItem>
      ))}
    </TextField>
  );
};

export default PrimaryClassificationSelector;
